module.exports = __webpack_public_path__ + "img/img-customer-satisfaction.b17241fd.svg";